import React from 'react';

import {
  AppBar,
  Toolbar,
  Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

import Account from './Account';
import Child from './Child';
import Menu from './Menu';
import * as selectorsUser from './selector';

import { uiSlice } from '@/domain/ui/redux';
import { userSlice } from '@/domain/user/redux';

const Header: React.FC = () => {
  const dispatch = useDispatch();
  const mode = useSelector(selectorsUser.modeSelector);
  const disabled = mode !== 'home';
  const onClick = () => {
    if (disabled) {
      dispatch(userSlice.actions.setMode('signin'));
    } else {
      dispatch(uiSlice.actions.setPage('home'));
    }
  };
  return (
    <AppBar position="static" elevation={0}>
      <Toolbar>
        <Menu disabled={disabled} />
        <Typography
          style={{ cursor: 'pointer' }}
          variant="h6"
          onClick={onClick}
        >
          Wagako
        </Typography>
        <Child />
        <div
          style={{ flexGrow: '1' }}
        />
        <Account disabled={disabled} />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
